import { render, staticRenderFns } from "./PhotosBlock.vue?vue&type=template&id=76c1f1ba&scoped=true&"
import script from "./PhotosBlock.vue?vue&type=script&lang=js&"
export * from "./PhotosBlock.vue?vue&type=script&lang=js&"
import style0 from "./PhotosBlock.vue?vue&type=style&index=0&id=76c1f1ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c1f1ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
